import {Component, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {select, Store} from "@ngrx/store";
import {AddZipcode} from "./actions/zipcode.actions";
import {selectFleet, selectUser, State} from "./reducers";
import {LoadTitles, TitlesActionTypes} from "./actions/titles.actions";
import {take, withLatestFrom} from "rxjs/operators";
import {SaveFleet} from "./actions/fleet.actions";
import {SaveFleetUser} from "./actions/fleet-user.actions";

@Component({
  selector: 'fleet-builder',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'fleet-builder';

  titles:Array<any>;

  user;

  fleet;

  constructor(private store:Store<State>) { }

  ngOnInit() {
    this.store.select(state=>state.titles)
      .subscribe(titles => this.titles = titles.titles);

    this.store.select(selectFleet)
      .subscribe(fleet => this.fleet = fleet);

    this.store.select(selectUser)
      .subscribe(user => this.user = user);

    this.store.dispatch(new LoadTitles());
  }

  // addLocation(zipcode:string) {
  //   this.store.dispatch(new AddZipcode(zipcode));
  // }

  saveFleetAndUser(formValues) {
    this.store.dispatch(new SaveFleetUser());
    // console.log(selectUser);
    // console.log(selectFleet);
    //
    // this.store.select(selectUser).pipe(take(1)).subscribe(
    //   val => console.log(val)
    // );
  }

}
